import type { ReactNode } from 'react';

export type ToolbarButtonProps = {
  onClick: () => void | Promise<void>;
  title: string;
  children: ReactNode;
};

export function ToolbarButton({ onClick, title, children }: ToolbarButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      aria-label={title}
      className="p-2 hover:bg-slate-100 dark:hover:bg-zinc-700 rounded-lg transition-colors text-slate-600 dark:text-zinc-400 hover:text-slate-900 dark:hover:text-white"
    >
      {children}
    </button>
  );
}

